import { Asset, FolderContent } from '@/api/generatedApi';
import { getAssetFileName } from '@/utils/assets';
import { Box, Paper, Typography } from '@mui/material';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import FolderIcon from '@mui/icons-material/Folder';

const ContentIcon = ({
  isMultiple,
  contentType,
}: {
  isMultiple: boolean;
  contentType: FolderContent['contentType'];
}) => {
  if (isMultiple) {
    return <FileCopyIcon sx={{ color: 'primary.main', fontSize: 24 }} />;
  }
  if (contentType === 'folder') {
    return <FolderIcon sx={{ color: 'primary.main', fontSize: 24 }} />;
  }
  return <InsertDriveFileIcon sx={{ color: 'primary.main', fontSize: 24 }} />;
};

const ContentLabel = ({ contents, firstContent }: { contents: FolderContent[]; firstContent: FolderContent }) => {
  const isMultiple = contents.length > 1;

  if (!isMultiple) {
    if (firstContent.contentType === 'folder') {
      return <Box component='span'>{firstContent.name}</Box>;
    }
    return <Box component='span'>{getAssetFileName(firstContent as Asset)}</Box>;
  }

  const folderCount = contents.filter(c => c.contentType === 'folder').length;
  const fileCount = contents.filter(c => c.contentType === 'asset').length;

  if (folderCount > 0 && fileCount > 0) {
    return <Box component='span'>{`${contents.length} items`}</Box>;
  }
  if (folderCount > 0) {
    return <Box component='span'>{`${folderCount} folders`}</Box>;
  }
  return <Box component='span'>{`${fileCount} files`}</Box>;
};

export const ContentDragPreview = ({ contents }: { contents: FolderContent[] }) => {
  const isMultiple = contents.length > 1;
  const firstContent = contents[0];

  return (
    <Paper
      elevation={8}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        padding: '8px 16px',
        borderRadius: '8px',
        backgroundColor: 'background.paper',
        border: '2px solid',
        borderColor: 'primary.main',
        maxWidth: 300,
        cursor: 'grabbing',
        opacity: 0.85,
      }}
    >
      <ContentIcon isMultiple={isMultiple} contentType={firstContent.contentType} />
      <Typography
        variant='body2'
        sx={{
          fontWeight: 500,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        <ContentLabel contents={contents} firstContent={firstContent} />
      </Typography>
    </Paper>
  );
};
